import { BrowserRouter as Router, Routes, Route, Outlet } from "react-router-dom";
import './style/style.scss'
import Footer from "./layouts/Footer";
import Index from "./pages/Index";
import Header from "./layouts/Header";
import PromptsInfo from "./pages/PromptsInfo";
import AccountInfo from "./pages/AccountInfo";
import Login from "./Auth/Login";
import PrivateRoutes from "./config/PrivateRoutes";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import { ToastContainer } from "react-toastify";
import BlogList from "./pages/Blogs_page/BlogList";
import BlogDetail from "./pages/Blogs_page/BlogDetail";
import HotPrompts from "./pages/v2/HotPrompts";
import PromptSubmit from "./pages/submitfrom/PromptSubmit";
import ReviewPanel from "./Auth/ReviewPanel";
import Pricing from "./pages/Pricing";
import AdminRoute from "./config/AdminRoute";
import { UserProvider } from "./context/UserContext";
import Upgrade from "./pages/Upgrade";
import ProfilePreview from "./pages/ProfilePreview";
import MasonryGrid from "./componets/MasonryGrid";
import AuthLogout from "./Auth/AuthLogout";
import Category from "./pages/Category/Category";
import CategoryPreview from "./pages/Category/CategoryPreview";
import Support from "./pages/Support";
import LoginPopup from "./componets/AutoLoginModal";
import ContactUs from "./pages/ContactUs";
import About from "./pages/About";
import ScrollToTop from "./componets/ScrollToTop";
import GenerateImage from "./pages/Generators/GenerateImage";


function App() {

     AuthLogout();

     function LoginLayout() {
          return (
               <div role="main">
                    <Header />
                    <Outlet />
               </div>
          );
     }
     function HomeLayout() {
          return (
               <div role="main">
                    <Header />
                    <Outlet />
                    <Footer />
               </div>
          );
     }

     function GenerationLayout() {
          return (
               <div role="main">
                    <Header />
                    <Outlet />
                    <Footer />
               </div>
          );
     }




     return (
          <UserProvider>
               <Router>
                    <LoginPopup />
                    <ScrollToTop />

                    <Routes>

                         <Route element={<LoginLayout />}>
                              <Route path='/login' element={<Login />} />
                              <Route path='/privacy-policy' element={<PrivacyPolicy />} />

                         </Route>


                         <Route element={<GenerationLayout />}>
                              <Route path="/ai-image-generator" element={<GenerateImage />} />
                         </Route>


                         <Route element={<HomeLayout />}>
                              <Route path='*' element={<Index />} />
                              <Route path='/about' element={<About />} />
                              <Route path="/gallery" element={<MasonryGrid />} />
                              <Route path="/support" element={<Support />} />
                              <Route path="/contact" element={<ContactUs />} />
                              <Route path='/prompts/:id' element={<PromptsInfo />} />
                              <Route path="/blogs" element={<BlogList />} />
                              <Route path="/blog/:slug" element={<BlogDetail />} />
                              <Route path="/pricing" element={<Pricing />} />
                              <Route path="/18+" element={<HotPrompts />} />
                              <Route path="/marketplace" element={<Upgrade />} />
                              <Route path="/category/:id" element={<Category />} />
                              <Route path="/:categoryId" element={<CategoryPreview />} />

                              <Route element={<PrivateRoutes />}>
                                   <Route path='/account' element={<AccountInfo />} />
                                   <Route path='/submit' element={<PromptSubmit />} />
                                   <Route path='/profile' element={<ProfilePreview />} />
                                   <Route path="/admin" element={<AdminRoute> <ReviewPanel /> </AdminRoute>} />

                                   {/* <Route path='/profile/:uid' element={<PreviewProfile />} /> */}
                                   {/* <Route path='/admin-bulk-upload' element={<BulkPromptUploader />} /> */}
                              </Route>
                         </Route>
                    </Routes>
                    <ToastContainer />
               </Router>
          </UserProvider>
     );
}

export default App;